import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=05ac0aa9&scoped=true"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"
import style0 from "./Cover.vue?vue&type=style&index=0&id=05ac0aa9&prod&scoped=true&lang=scss"
import style1 from "./Cover.vue?vue&type=style&index=1&id=05ac0aa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac0aa9",
  null
  
)

export default component.exports